import paper from "paper";
import {ComplexMusicPaperShape} from '@consts/types'
import convertColorForPaperJS from '../utils/convert-color/convert-color'
import {AbstractFigure} from './core/abstract-figure'

export class Polygon extends AbstractFigure<paper.Path, ComplexMusicPaperShape> {
  protected initCoreFigure(paperScope: paper.PaperScope, shape: ComplexMusicPaperShape): paper.Path {
    const { color, shapeScheme: { points } } = shape;
    const path = new paperScope.Path();
    path.closed = true;

    points.forEach((pointData) => {
      const point = new paperScope.Point(pointData);
      path.add(point)
    });

    if (this.isSmoothFigure()) path.smooth();
    path.fillColor = convertColorForPaperJS(path, color);
    return path;
  }

  protected isCanChangePoints() {
    return true;
  }

  protected updateCoreFigureByShapeData(
    coreShape: paper.Path,
    shapeData: ComplexMusicPaperShape,
    paperScope: paper.PaperScope
  ) {
    const { color, shapeScheme: { points } } = shapeData;
    coreShape.removeSegments();

    points.forEach((pointData) => {
      const point = new paperScope.Point(pointData);
      coreShape.add(point)
    });

    if (this.isSmoothFigure()) coreShape.smooth();
    coreShape.fillColor = convertColorForPaperJS(coreShape, color);
  }

  protected serializationToShapeData(coreFigure: paper.Path, shape: ComplexMusicPaperShape): ComplexMusicPaperShape {
    return {
      ...shape,
      shapeScheme: {
        points: coreFigure.segments.map((segment) => ({
          x: segment.point.x,
          y: segment.point.y,
        }))
      }
    }
  }
}
